// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2PctF","paramInput":"JobSimulator_paramInput__DnGES","input":"JobSimulator_input__3BP6k"};